import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroLoans from "./HeaderIntroLoans";
export class CarLoan extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroLoans />
        </div>

        <section id="about">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>CAR LOANS</h3>
              <p>
                Millions of Indians today are upwardly mobile, and on the move.
                Many are looking at having their own car to reach their
                destination in time and in comfort. Now, the years of waiting
                and saving are over. A Car Loan will bring that dream of owning
                a vehicle within your reach.
                <br />
                At ClipTax, we offer Car Loans with easy equated monthly
                instalments (EMIs), which make it easier to afford a car without
                disturbing one's budget.
              </p>
            </header>
          </div>
        </section>

        <section id="why-us">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>HOW IT WORKS?</h3>
              {/* <p>
                Any business offering sale of goods with annual turn over of 40
                lacs or service with annual turn over of 20 lacs would require
                the registration for GST and have a valid GST Number.
              </p> */}
            </header>

            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  <i class="fa fa-diamond"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 1:</h5>
                    <p class="card-text">
                      Quick Register : Fill up a Simple Form
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  <i class="fa fa-language"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 2:</h5>
                    <p class="card-text">
                      Select From Multiple Offers : List of Offers from Multiple
                      Banks Banks
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  <i class="fa fa-object-group"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 3:</h5>
                    <p class="card-text">
                      Apply : Quick Application in less than 15 mins{" "}
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>BENEFITS AND FEATURES OF CAR LOANS</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Customized EMIs</a>
                  </h4>
                  <p class="description">
                    One can easily customize the EMI structure now as per his
                    repayment ability while negotiating with the lender. You can
                    easily cut down your EMI payments which you are entitled to
                    pay over the tenure of the loan by initially paying a wider
                    margin amount.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">
                      Negotiation of interest rate and choosing interest rate
                      option
                    </a>
                  </h4>
                  <p class="description">
                    A good credit score and a healthy relationship are the two
                    main aspects of with your bank gives you the benefit of
                    negotiation of interest rate with the lender. You can decide
                    the type of interest rate for your loan whether fixed or
                    floating rate. The interest rate will then depend on the
                    type of interest rate you have chosen.
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Flexibility to choose the payment method</a>
                  </h4>
                  <p class="description">
                    You get the option to choose to pay either via post-dated
                    cheques or by using auto-debit facility where your EMIs
                    (equated monthly instalments) will be automatically deducted
                    from your bank accounts.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Loan for pre-owned cars</a>
                  </h4>
                  <p class="description">
                    Many banks offer loan on used car these days. Although the
                    interest rate will be higher for the used car loan than the
                    interest rate on new car loan and the loan-to-value (LTV)
                    ratio will be lower than the new car loan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>DOCUMENTS REQUIRED FOR PERSONAL LOAN</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Photo Identity Proof</a>
                  </h4>
                  <p class="description">
                   A copy of your Voter ID/ Passport/ Driving License/ Aadhar Card
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Income Proof</a>
                  </h4>
                  <p class="description">
                   A copy of your Bank statements for the last six months 
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Salary Slips</a>
                  </h4>
                  <p class="description">
                    A copy of your Salary Slips for the last three months
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Address Proof</a>
                  </h4>
                  <p class="description">
                    A copy of your Ration Card / Electricity Bill / Passport
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Vehicle Registration Certificate</a>
                  </h4>
                  <p class="description">
                    A copy of your Vehicle's registration certificate
                  </p>
                </div>
              </div>
              
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Telephone/Mobile Connection</a>
                  </h4>
                  <p class="description">
                    A copy of your telephone/ mobile bill is required
                  </p>
                </div>
              </div>

            </div>


          </div>

          
        </section>
        <Footer />
      </div>
    );
  }
}

export default CarLoan;
